import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { PlacementType } from '@/__generated__/adSlotQuery.graphql';

export const adLabIdsAtom = atomWithStorage<Record<PlacementType, string>>(
  'refund_ad_lab-ids',
  {} as Record<PlacementType, string>,
  createJSONStorage(() => localStorage)
);
